import type { ResolvedConnectorDefinition } from '#layers/data-model/types/data-connectors/define';
import type { ResolvedMonospaceDataSource } from '#layers/data-model/types/schema/resolved-schema';

export type ConnectorLookupMap = Record<string, ResolvedConnectorDefinition<any>>;

export type DataSourceConnectorRef = Pick<ResolvedMonospaceDataSource, 'provider' | 'preset'>;

/**
 * Resolve the connector definition backing a data source, preferring its
 * preset (e.g. Supabase) over the bare provider (e.g. PostgreSQL) only when they match.
 */
export function getConnectorForDataSource(
	source: DataSourceConnectorRef,
	connectorsById: ConnectorLookupMap,
	connectorsByProvider: ConnectorLookupMap,
) {
	const provider = String(source.provider);
	const preset = source.preset ? String(source.preset) : undefined;

	const presetConnector = preset ? connectorsById[preset] : undefined;
	if (presetConnector?.provider === provider) return presetConnector;

	return connectorsByProvider[provider];
}
